<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_vii"></a>Contents</h2>
<p class="toc1b"><em><a class="nounder" href="#/xhtml/Preface">Preface</a></em></p>
<p class="toc"><a class="nounder" href="#/xhtml/chapter1">1 Introduction: The Supreme Court before John Marshall</a></p>
<p class="toc1"><em>Scott Douglas Gerber</em></p>
<p class="toc"><a class="nounder" href="#/xhtml/chapter2">2 “Honour, Justice, and Interest”: John Jay’s Republican Politics and Statesmanship on the Federal Bench</a></p>
<p class="toc1"><em>Sandra Frances VanBurkleo</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter3" title="Link target outside of Sample">3 John Rutledge: Distinction and Declension</span></p>
<p class="toc1"><em>James Haw</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter4" title="Link target outside of Sample">4 Deconstructing William Cushing</span></p>
<p class="toc1"><em>Scott Douglas Gerber</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter5" title="Link target outside of Sample">5 James Wilson: Democratic Theorist and Supreme Court Justice</span></p>
<p class="toc1"><em>Mark D. Hall</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter6" title="Link target outside of Sample">6 John Blair: “A Safe and Conscientious Judge”</span></p>
<p class="toc1"><em>Wythe Holt</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter7" title="Link target outside of Sample">7 James Iredell: Revolutionist, Constitutionalist, Jurist</span></p>
<p class="toc1"><em>Willis P. Whichard</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter8" title="Link target outside of Sample">8 William Paterson: Small States’ Nationalist</span></p>
<p class="toc1"><em>Daniel A. Degnan, S.J.</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter9" title="Link target outside of Sample">9 The Verdict on Samuel Chase and His “Apologist”</span></p>
<p class="toc1"><em>Stephen B. Presser</em></p>
<p class="toc"><a id="page_viii"></a><span class="nounder" href="#/xhtml/chapter10" title="Link target outside of Sample">10 Oliver Ellsworth: “I have sought the felicity and glory of your Administration”</span></p>
<p class="toc1"><em>William R. Casto</em></p>
<p class="toc"><span class="nounder" href="#/xhtml/chapter11" title="Link target outside of Sample">11 Heir Apparent: Bushrod Washington and Federal Justice in the Early Republic</span></p>
<p class="toc1"><em>James R. Stoner, Jr.</em></p>
<p class="toc1a"><em><a class="nounder" href="#/xhtml/Editorsnote">Editor’s Note</a></em></p>
<p class="toc1a1"><em><span class="nounder" href="#/xhtml/Contributors" title="Link target outside of Sample">Contributors</span></em></p>
<p class="toc1a1"><em><span class="nounder" href="#/xhtml/Index" title="Link target outside of Sample">Index</span></em></p>
<p class="toc1a1"><em><a class="nounder" href="#/xhtml/AbouttheEditor">About the Editor</a></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?6d3a85ce